// AdminAnalyticsPie.styles.js
import styled from 'styled-components';

export const ChartContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  ${(props) => props.className || ''}
`;

export const HeaderContainer = styled.div`
  margin-bottom: 1rem;
`;

export const HeaderTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
  line-height: 1.75rem;
`;

export const HeaderSubtitle = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.25rem;
`;

export const ChartWrapper = styled.div`
  position: relative;
  height: ${(props) => props.height || 400}px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const LoadingSpinner = styled.div`
  width: 3rem;
  height: 3rem;
  border: 2px solid transparent;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ChartCanvas = styled.canvas`
  width: 100%;
  height: 100%;
`;
